module.exports = __webpack_public_path__ + "static/media/toggeList.571f0096.svg";